import { render, staticRenderFns } from "./UserOrderList.vue?vue&type=template&id=6c79c680&scoped=true"
import script from "./UserOrderList.vue?vue&type=script&lang=js"
export * from "./UserOrderList.vue?vue&type=script&lang=js"
import style0 from "./UserOrderList.vue?vue&type=style&index=0&id=6c79c680&lang=scss&scoped=true"
import style1 from "./UserOrderList.vue?vue&type=style&index=1&id=6c79c680&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c79c680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c79c680')) {
      api.createRecord('6c79c680', component.options)
    } else {
      api.reload('6c79c680', component.options)
    }
    module.hot.accept("./UserOrderList.vue?vue&type=template&id=6c79c680&scoped=true", function () {
      api.rerender('6c79c680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/UserOrderList.vue"
export default component.exports